module.exports = __webpack_public_path__ + "static/media/login-img.35e32ebc.png";